import type { ReactElement } from 'react';

export default function FullPageLoader(): ReactElement {
	return <p>Loading...</p>;
}
